import { render, staticRenderFns } from "./printcollection.vue?vue&type=template&id=1d25eb84&scoped=true&"
import script from "./printcollection.vue?vue&type=script&lang=js&"
export * from "./printcollection.vue?vue&type=script&lang=js&"
import style0 from "./printcollection.vue?vue&type=style&index=0&id=1d25eb84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25eb84",
  null
  
)

export default component.exports